import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { IItemModalCallSheet } from "../../../../config/interfaces";
import UnstyledSwitches from "./switch";
import "./index.scss";

const ItemModalCallSheet = (props: {
  item: IItemModalCallSheet;
  onChange: any;
}) => {
  const { item, onChange } = props;
  const { text } = item;
  const setValue = (e: any) => {
    onChange(e.target.checked);
  };
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #ccc",
      }}
    >
      <Typography
        component="p"
        variant="body1"
        sx={{
          alignSelf: "center",
        }}
      >
        {text}
      </Typography>
      <UnstyledSwitches setValue={setValue} />
    </Box>
  );
};

export default ItemModalCallSheet;
